import type { FormSchema } from '@/app/register/schema';
import { formatDate } from '@/utils/date';
import {
  UpdateUserCareerParams,
  UpdateUserProfileParams
} from '../../types/user';
import { companyIdInitialValue } from '@/app/register/_workplace/schema';

const initialCareerHistory = {
  companyId: companyIdInitialValue,
  companyName: '',
  joinedDate: '',
  retiredDate: '',
  stayNow: false
} as const;
import getKeys from '../../utils/getKeys';

export const buildUpdateUserProfileParams = ({
  lastname,
  firstname,
  gender,
  birthday,
  phonenumber,
  prefecture
}: Partial<FormSchema>): UpdateUserProfileParams => {
  const { year, month, day } = birthday || {};

  return {
    lastName: lastname || undefined,
    firstName: firstname || undefined,
    gender: gender || undefined,
    birthday:
      year && month && day
        ? formatDate(new Date(`${year}/${month}/${day}`), 'YYYY年MM月DD日')
        : undefined,
    telephoneNumber: phonenumber || undefined,
    prefectureId: prefecture || undefined
  };
};

/**
 * @param decreasesFromCareerHistories 所属企業から減らした企業数
 */
export const buildUpdateUserCareerParams = (
  {
    degree,
    university,
    major,
    graduationyear,
    workplace,
    jobexperience,
    // ownedskills,
    annualincome
  }: Partial<FormSchema>,
  decreasesFromCareerHistories: number = 0
): UpdateUserCareerParams => {
  const formattedCareerHistories = workplace?.map(
    ({
      companyOrder,
      companyId,
      companyName,
      joinedDate,
      retiredDate,
      stayNow,
      isLatest
    }) => ({
      companyOrder,
      companyId,
      companyName,
      joinedDate: joinedDate
        ? formatDate(
            new Date(`${joinedDate.year}-${joinedDate.month}`),
            'YYYY年MM月'
          )
        : '',
      retiredDate: retiredDate
        ? formatDate(
            new Date(`${retiredDate.year}-${retiredDate.month}`),
            'YYYY年MM月'
          )
        : '',
      isStillEmployed: stayNow,
      isLatest
    })
  );

  return {
    finalEducation: {
      universityId: university?.id,
      universityName: university?.name,
      degreeId: degree,
      majorId: major?.id,
      endPeriod:
        graduationyear?.year && graduationyear?.month
          ? formatDate(
              new Date(`${graduationyear.year}/${graduationyear.month}/01`),
              'YYYY年MM月'
            )
          : ''
    },
    careerHistories: formattedCareerHistories
      ? [
          ...formattedCareerHistories,
          ...Array.from({
            length: Math.max(0, decreasesFromCareerHistories)
          }).map(_ => initialCareerHistory)
        ]
      : undefined,
    experiencedJobs: jobexperience
      ? getKeys(jobexperience).flatMap(category =>
          jobexperience[category].map(({ jobName, ...other }) => other)
        )
      : undefined,
    // skills: ownedskills
    //   ? ownedskills.map(({ skillId, level }) => ({
    //       skillId,
    //       level
    //     }))
    //   : undefined,
    annualIncome: annualincome
  };
};
